module.exports = __webpack_public_path__ + "img/marker-2.c73c82e1.svg";